import React from 'react';
import './libs/glob.js';
import ReactDOM from 'react-dom/client';
import './media/css/index.css';
import App from './pages/App.mjs';
import G from "./libs/Glob.mjs";

const root = ReactDOM.createRoot(G.prop.appRootNode);
root.render(
	<React.StrictMode>
		<App/>
	</React.StrictMode>
);
